<template>
  <div :class="['ms-form', 'contractor-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <!-- Поля сгруппированы по смыслу; логика и обязательность полей прежние -->
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building" aria-hidden="true" />Основное</h3>
        <div class="ms-form-grid">
          <CustomInput label="Наименование" type="text" :required="true" :value="this.formData.contractor_name"
            @change_input="(value) => onChange('contractor_name', value)" />
          <CustomInput label="Юридическое наименование" type="text" :required="true" :value="this.formData.legal_name"
            @change_input="(value) => onChange('legal_name', value)" />
          <CustomInput label="БИН" type="text" :required="true" :value="this.formData.bin"
            @change_input="(value) => onChange('bin', value)" />
          <div>
            <div class="ms-form-label">НДС</div>
            <div class="ms-seg contractor-form__seg">
              <button v-for="opt in isNdsOptions" :key="String(opt.value)" type="button"
                :class="{ active: this.formData.is_nds === opt.value }" @click="onChange('is_nds', opt.value)">
                {{ opt.label }}
              </button>
            </div>
          </div>
          <CustomSelect :options="contractorTypeOptions" label="Тип подрядчика" :required="true"
            optionValueKey="contractor_type_id" optionLabelKey="contractor_type_name"
            :value="this.formData.contractor_type_id || ''"
            @change="(value) => onChange('contractor_type_id', value)" />
          <CustomSelect :options="contragentTypeOptions" label="Тип контрагента" :required="true"
            optionValueKey="contragent_type_id" optionLabelKey="contragent_type_name"
            :value="this.formData.contragent_type_id || ''"
            @change="(value) => onChange('contragent_type_id', value)" />
          <CustomSelect :options="cityOptions" label="Город" :required="true" optionValueKey="city_id"
            optionLabelKey="city_name" :value="this.formData.city_id || ''"
            @change="(value) => onChange('city_id', value)" />
          <CustomSelect :options="taxoparkOptions" label="Таксопарк" :required="true" optionValueKey="taxopark_id"
            optionLabelKey="taxopark_name" :value="this.formData.taxopark_id || ''"
            @change="(value) => onChange('taxopark_id', value)" />
          <CustomSelect :options="contractorMainTypeOptions" label="Подрядчик" optionValueKey="contractor_main_id"
            optionLabelKey="contractor_main_name" :value="this.formData.contractor_main_id || ''"
            @change="(value) => onChange('contractor_main_id', value)" />
          <CustomInput label="Лимит" type="number" :value="this.formData.contractor_limit"
            @change_input="(value) => onChange('contractor_limit', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-address-card" aria-hidden="true" />Руководитель и контакты</h3>
        <div class="ms-form-grid">
          <CustomInput label="Полное ФИО директора" type="text" :value="this.formData.director_fio"
            class="ms-form-wide" @change_input="(value) => onChange('director_fio', value)" />
          <CustomInput label="Телефон" type="text" :required="true" :value="this.formData.phone"
            @change_input="(value) => onChange('phone', value)" />
          <CustomInput label="Email" type="email" :required="true" :value="this.formData.email"
            @change_input="(value) => onChange('email', value)" />
          <CustomInput label="Юридический адрес" type="textarea" :required="true" :value="this.formData.address"
            @change_input="(value) => onChange('address', value)" />
          <CustomInput label="Контакты" type="textarea" :value="this.formData.contacts"
            @change_input="(value) => onChange('contacts', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building-columns" aria-hidden="true" />Банковские реквизиты</h3>
        <div class="ms-form-grid">
          <CustomInput label="ИИК" type="text" :value="this.formData.iik"
            @change_input="(value) => onChange('iik', value)" :required="true" />
          <CustomInput label="Наименование банка" type="text" :value="this.formData.account_name"
            @change_input="(value) => onChange('account_name', value)" :required="true" />
          <CustomInput label="БИК" type="text" :value="this.formData.bik"
            @change_input="(value) => onChange('bik', value)" :required="true" />
          <CustomInput label="КБе" type="number" :value="this.formData.kbe"
            @change_input="(value) => onChange('kbe', value)" :required="true" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-file-signature" aria-hidden="true" />Договор присоединения</h3>
        <div class="ms-form-grid">
          <CustomInput label="№ договора" type="number" :value="this.formData.accession_contract_num"
            @change_input="(value) => onChange('accession_contract_num', value)" />
          <CustomDate :fullWidth="true" label="Дата договора" :value="this.formData.accession_contract_date"
            @change_date="(value) => onChange('accession_contract_date', value)" />
          <div class="ms-form-wide contractor-form__signed">
            <CustomCheckbox label="Договор присоединения подписан" :value="this.formData.is_signed_accession_contract"
              :binary="true" @change="(value) => onChange('is_signed_accession_contract', value)" />
          </div>
          <div class="ms-form-wide">
            <CustomUploader :value="this.formData?.document" :on-change="(value) => this.onChange('document', value)"
              label="Файл договора присоединения" />
          </div>
          <CustomInput label="Текст для договора" type="textarea" :value="this.formData.contract_text"
            class="ms-form-wide" @change_input="(value) => onChange('contract_text', value)" />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-link" aria-hidden="true" />Интеграции</h3>
        <div class="ms-form-grid">
          <CustomInputDropdown :options="contragentSBSOptions" label="Заказчик SBS (поиск по БИН или наименованию)"
            @change_input="(val) => this.contragentSBSFilterFunc(val)" optionValueKey="sbs_company_id"
            optionLabelKey="naimenovanie" :value="this.formData.sbs_company_name || ''"
            :loading="this.contragentSBSLoading" @select_item="this.contragentSBSSelectItem" />
          <CustomInputDropdown :options="partnerSBSOptions" label="Подрядчик SBS (поиск по БИН или наименованию)"
            optionValueKey="sbs_partner_id" optionLabelKey="naimenovanie" :value="this.formData.sbs_partner_name || ''"
            :loading="this.partnerSBSLoading" @change_input="(val) => this.partnerSBSFilterFunc(val)"
            @select_item="this.partnerSBSSelectItem" />
          <CustomInput label="ГУИД (1С)" type="text" :value="this.formData.guid"
            @change_input="(value) => onChange('guid', value)" />
          <CustomInput label="Код для номера спецификации" type="text"
            :value="this.formData.contractor_code" @change_input="(value) => onChange('contractor_code', value)" />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInputDropdown from "@/components/form/CustomInputDropdown";
import CustomUploader from "@/components/form/CustomUploader";
import { getCity, getTaxopark, getContractorType, getContragentType, getContractorMainType, mapSBSCompany, mapSBSPartner } from "@/views/handbook/contractors/services";

export default {
  name: "add-handbook-contractor",
  components: { CustomInput, CustomSelect, CustomInputDropdown, CustomModalFooter, CustomDate, CustomCheckbox, CustomUploader },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        contractor_name: this.data?.body?.contractor_name || '',
        director_fio: this.data?.body?.director_fio_myspace || '',
        legal_name: this.data?.body?.legal_name || '',
        guid: this.data?.body?.guid || '',
        bin: this.data?.body?.bin || '',
        address: this.data?.body?.address || '',
        city_id: this.data?.body?.city_id || '',
        taxopark_id: this.data?.body?.taxopark_id || '',
        contractor_type_id: this.data?.body?.contractor_type_id || '',
        contragent_type_id: this.data?.body?.contragent_type_id || '',
        contacts: this.data?.body?.contacts || '',
        iik: this.data?.body?.iik || '',
        account_name: this.data?.body?.account_name || '',
        bik: this.data?.body?.bik || '',
        kbe: this.data?.body?.kbe || '',
        contract_text: this.data?.body?.contract_text || '',
        contractor_limit: this.data?.body?.contractor_limit || '',
        accession_contract_num: this.data?.body?.accession_contract_num || '',
        accession_contract_date: this.data?.body?.accession_contract_date || '',
        document: '',
        is_signed_accession_contract: this.data?.body?.is_signed_accession_contract || 0,
        phone: this.data?.body?.phone || '',
        email: this.data?.body?.email || '',
        contractor_code: this.data?.body?.contractor_code || '',
        contractor_main_id: this.data?.body?.contractor_main_id || '',
        sbs_company_id: this.data?.body?.sbs_company_id || '',
        sbs_partner_id: this.data?.body?.sbs_partner_id || '',
        sbs_partner_name: this.data?.body?.sbs_partner_name || '',
        sbs_company_name: this.data?.body?.sbs_company_name || '',
        is_nds: this.data?.body?.is_nds !== undefined ? this.data?.body?.is_nds : null,
      },
      cityOptions: [],
      taxoparkOptions: [],
      contractorTypeOptions: [],
      contragentTypeOptions: [],
      partnerSBSOptions: [],
      contragentSBSOptions: [],
      contractorMainTypeOptions: [],
      contragentSBSLoading: false,
      partnerSBSLoading: false,
      sbsCompanySearchTimeout: null,
      sbsPartnerSearchTimeout: null,
      isNdsOptions: [
        { label: 'Не выбрано', value: null },
        { label: 'НДС', value: true },
        { label: 'Без НДС', value: false },
      ],
    }
  },
  methods: {
    contragentSBSSelectItem(value, obj) {
      if (!obj || obj === null || obj === undefined) {
        this.formData = {
          ...this.formData,
          sbs_company_id: null,
          sbs_company_name: ''
        };
      } else {
        this.formData = {
          ...this.formData,
          sbs_company_id: obj.sbs_company_id,
          sbs_company_name: obj.naimenovanie
        };
      }
    },
    partnerSBSSelectItem(value, obj) {
      if (!obj || obj === null || obj === undefined) {
        this.formData = {
          ...this.formData,
          sbs_partner_id: null,
          sbs_partner_name: ''
        };
      } else {
        this.formData = {
          ...this.formData,
          sbs_partner_id: obj.sbs_partner_id,
          sbs_partner_name: obj.naimenovanie
        };
      }
    },
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchCities() {
      this.cityOptions = await getCity();
    },
    async fetchTaxoparks() {
      this.taxoparkOptions = await getTaxopark();
    },
    async fetchContractorType() {
      this.contractorTypeOptions = await getContractorType();
    },
    async fetchContragentType() {
      this.contragentTypeOptions = await getContragentType();
    },
    async fetchContractorMainType() {
      this.contractorMainTypeOptions = await getContractorMainType();
    },
    async contragentSBSFilterFunc(value) {
      if (!value) {
        this.formData.sbs_company_id = '';
        this.formData.sbs_company_name = '';
        this.contragentSBSOptions = [];
        this.contragentSBSLoading = false;
        return;
      }

      this.formData.sbs_company_name = value;

      if (this.sbsCompanySearchTimeout) {
        clearTimeout(this.sbsCompanySearchTimeout);
      }

      if (value.length >= 3) {
        this.contragentSBSLoading = true;

        this.sbsCompanySearchTimeout = setTimeout(async () => {
          let body = { search_text: value };
          const response = await mapSBSCompany(body);
          this.contragentSBSOptions = response || [];
          this.contragentSBSLoading = false;
        }, 300);
      } else {
        this.contragentSBSOptions = [];
        this.contragentSBSLoading = false;
      }
    },
    async partnerSBSFilterFunc(value) {
      this.formData.sbs_partner_name = value;

      if (!value) {
        this.formData.sbs_partner_id = '';
        this.formData.sbs_partner_name = '';
        this.partnerSBSOptions = [];
        this.partnerSBSLoading = false;
        return;
      }

      if (this.sbsPartnerSearchTimeout) {
        clearTimeout(this.sbsPartnerSearchTimeout);
      }

      if (value?.length >= 3) {
        this.partnerSBSLoading = true;

        this.sbsPartnerSearchTimeout = setTimeout(async () => {
          let body = { search_text: value }
          const response = await mapSBSPartner(body);
          this.partnerSBSOptions = response || [];
          this.partnerSBSLoading = false;
        }, 300);
      } else {
        this.partnerSBSOptions = [];
        this.partnerSBSLoading = false;
      }
    },
  },
  mounted() {
    this.fetchCities();
    this.$watch('cityOptions', (newOptions) => {
      if (newOptions.length && !this.formData.city_id) {
        this.formData.city_id = newOptions[0].city_id;
      }
    });
    this.fetchTaxoparks();
    this.$watch('taxoparkOptions', (newOptions) => {
      if (newOptions.length && !this.formData.taxopark_id) {
        this.formData.taxopark_id = newOptions[0].taxopark_id;
      }
    });
    this.fetchContractorType();
    this.fetchContragentType();
    this.fetchContractorMainType();
  },
  beforeUnmount() {
    if (this.sbsCompanySearchTimeout) {
      clearTimeout(this.sbsCompanySearchTimeout);
    }
    if (this.sbsPartnerSearchTimeout) {
      clearTimeout(this.sbsPartnerSearchTimeout);
    }
  }
}
</script>

<style scoped lang="scss">
// Блоки, сетка и футер — общие (ms-form-* в theme.scss, футер в components/modal/index.vue)
.contractor-form {
  &__seg {
    height: 40px;
    width: 100%;

    button {
      flex: 1;
    }
  }

  &__signed {
    margin: -4px 0 -4px -8px;
  }
}
</style>
